// gatsby-browser.js
import * as React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { StoreProvider } from './src/context/store-context'
import { CustomerSyncProvider } from './src/context/customer-sync'
import Layout from './src/components/Layout/Layout'
import './src/styles/reset.css'
import './src/styles/variables.css'
import './src/styles/global.css'
import './src/styles/public.less'
import AOS from 'aos'
import 'aos/dist/aos.css'

export const wrapRootElement = ({ element }) => {
  return (
    <Auth0Provider
      domain={process.env.GATSBY_AUTH0_DOMAIN}
      clientId={process.env.GATSBY_AUTH0_CLIENTID}
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri:
          process.env.GATSBY_AUTH0_CALLBACK || window.location.origin,
      }}
    >
      <StoreProvider>
        <CustomerSyncProvider>{element}</CustomerSyncProvider>
      </StoreProvider>
    </Auth0Provider>
  )
}

export const wrapPageElement = ({ element, props }) => {
  AOS.init({
    duration: 800,
    offset: 120,
    once: true,
    easing: 'ease-in-out',
  })
  return <Layout {...props}>{element}</Layout>
}
